var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.emptyComponent,_vm._b({tag:"component",staticClass:"loadable-content",attrs:{"md-label":_vm.label,"md-description":_vm.description,"md-icon":_vm.icon}},'component',_vm.$attrs,false),[(_vm.loading && !_vm.error)?_c('md-progress-spinner',{attrs:{"md-mode":"indeterminate"}}):_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/LoadingContent.vue